import LocalizedStrings from 'localized-strings';

const dashboardLocales = new LocalizedStrings({
  en: {
    beta: {
      dataTooltip: 'Only 2023 data is currently available.',
      tag: 'BETA',
    },
    feedback: {
      feedbackCTA: 'Give some feedback',
      feedbackLink: 'https://shinetools.typeform.com/to/IXJ8yyyK',
    },
    operationType: {
      card: 'Card transactions',
      check: 'Check',
      deposit: 'Cash',
      transfer: 'Transfer',
      withdrawal: 'Cash withdrawals',
    },
    transactionCount: {
      plural: '{count} transactions',
      singular: '{count} transaction',
    },
  },
  fr: {
    beta: {
      dataTooltip: 'Seules les données de 2023 sont aujourd’hui accessibles.',
      tag: 'BETA',
    },
    feedback: {
      feedbackCTA: 'Faites-nous vos retours',
      feedbackLink: 'https://shinetools.typeform.com/to/IXJ8yyyK',
    },
    operationType: {
      card: 'Opérations par carte',
      check: 'Chèques',
      deposit: 'Espèces',
      transfer: 'Virements',
      withdrawal: 'Retraits d’argent',
    },
    transactionCount: {
      plural: '{count} transactions',
      singular: '{count} transaction',
    },
  },
} as const);

export default dashboardLocales;
